export default __webpack_public_path__ + "static/media/consumables.2787f1bd.svg";